import { render, staticRenderFns } from "./statistics-rooms.vue?vue&type=template&id=063c58a8&"
import script from "./statistics-rooms.vue?vue&type=script&lang=js&"
export * from "./statistics-rooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports